<!-- 标签 -->
<template>
  <div class="text" :style="{ background: lightColor(color) }">
    <p :style="{ color: color }">{{ text }}</p>
  </div>
</template>
<script>
export default {
  name: "matrix-tag",
  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
  },
  data() {
    return {};
  },
  computed: {
    lightColor() {
      return function (e) {
        return "rgba(" + parseInt("0x" + e.slice(1, 3)) + "," + parseInt("0x" + e.slice(3, 5)) + "," + parseInt("0x" + e.slice(5, 7)) + "," + 0.08 + ")";
      }
    }
  },
};
</script>

<style scoped lang="scss">
.text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  box-sizing: border-box;
  border-radius: 50px;
  text-align: center;
  padding: 3px 6px;

  p {
    margin: 0;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
